import React, { memo } from "react";
import { Button } from "@material-ui/core";
import { Refresh } from "@material-ui/icons";
import "./styles.css";

const UpdateCalculationsButton = ({ onSubmit }) => (
  <Button onClick={onSubmit} style={{ alignItems: "center" }}>
    <div className="run-table-update-calculations-button-wrapper">
      <span style={{ marginTop: "2.5px" }}><Refresh /></span>
      <span className="run-table-update-calculations-button-text">Update Loan Proceeds Calculations</span>
    </div>
  </Button>
);

export default memo(UpdateCalculationsButton);
